<template>
  <input type="hidden" :name="param" :value="token" />
</template>

<script>

// Rails' CSRF token, read from the csrf_meta_tags in the layout, so plain
// <form method="post"> submissions from Vue pass verify_authenticity_token.
function meta(name) {
  const element = document.head.querySelector(`meta[name='${name}']`)
  return element ? element.content : null
}

export default {
  data() {
    return {
      param: meta('csrf-param') || 'authenticity_token',
      token: meta('csrf-token'),
    }
  }
}
</script>
